import { ActionTypes, BurstSettingActions } from './burst-settings.actions';
import { BurstSettingState } from './burst-settings.model';

export const burstSettingState: BurstSettingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getBurstSettingLoading: false,
  getBurstSettingLoaded: false,
  burstSetting: null,
  addBurstSettingLoading: false,
  addBurstSettingLoaded: false,
  editBurstSettingLoading: false,
  editBurstSettingLoaded: false,
  deleteBurstSettingsLoading: false,
  deleteBurstSettingsLoaded: false,
  siteDataLoading: false,
  siteDataLoaded: false,
  siteData: [],
  lineDataLoading: false,
  lineDataLoaded: false,
  lineData: null,
  allLinesDataLoading: false,
  allLinesDataLoaded: false,
  allLinesData: [],
};

export function burstSettingReducer(
  state: BurstSettingState = burstSettingState,
  action: BurstSettingActions,
): BurstSettingState {
  switch (action.type) {
    case ActionTypes.BURST_SETTINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.BURST_SETTINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_BURST_SETTING:
      return {
        ...state,
        getBurstSettingLoading: true,
        getBurstSettingLoaded: false,
      };
    case ActionTypes.GET_BURST_SETTING_COMPLETED:
      return {
        ...state,
        burstSetting: action.payload.data,
        getBurstSettingLoading: false,
        getBurstSettingLoaded: true,
      };
    case ActionTypes.ADD_BURST_SETTING:
      return {
        ...state,
        addBurstSettingLoading: true,
        addBurstSettingLoaded: false,
      };
    case ActionTypes.ADD_BURST_SETTING_COMPLETED:
      return {
        ...state,
        addBurstSettingLoading: false,
        addBurstSettingLoaded: true,
      };
    case ActionTypes.EDIT_BURST_SETTING:
      return {
        ...state,
        editBurstSettingLoading: true,
        editBurstSettingLoaded: false,
      };
    case ActionTypes.EDIT_BURST_SETTING_COMPLETED:
      return {
        ...state,
        editBurstSettingLoading: false,
        editBurstSettingLoaded: true,
      };
    case ActionTypes.DELETE_BURST_SETTINGS:
      return {
        ...state,
        deleteBurstSettingsLoading: true,
        deleteBurstSettingsLoaded: false,
      };
    case ActionTypes.DELETE_BURST_SETTINGS_COMPLETED:
      return {
        ...state,
        deleteBurstSettingsLoading: false,
        deleteBurstSettingsLoaded: true,
      };
    case ActionTypes.SITES_DATA_LOADING:
      return {
        ...state,
        siteDataLoading: true,
        siteDataLoaded: false,
      };
    case ActionTypes.SITES_DATA_COMPLETED:
      return {
        ...state,
        siteData: action.payload,
        siteDataLoading: false,
        siteDataLoaded: true,
      };
    case ActionTypes.LINES_DATA_LOADING:
      return {
        ...state,
        lineDataLoading: true,
        lineDataLoaded: false,
      };
    case ActionTypes.LINES_DATA_COMPLETED:
      return {
        ...state,
        lineData: action.payload,
        lineDataLoading: false,
        lineDataLoaded: true,
      };
    case ActionTypes.ALL_LINES_DATA_LOADING:
      return {
        ...state,
        allLinesDataLoading: true,
        allLinesDataLoaded: false,
      };
    case ActionTypes.ALL_LINES_DATA_COMPLETED:
      return {
        ...state,
        allLinesData: (action.payload?.data ?? []).map((line) => ({ id: Number(line.id), name: line.title })),
        allLinesDataLoading: false,
        allLinesDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
